import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "text-caption text-grey-9" }
const _hoisted_2 = {
  key: 0,
  class: "q-pb-sm"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_toolbar_title = _resolveComponent("q-toolbar-title")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_badge = _resolveComponent("q-badge")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_btn_dropdown = _resolveComponent("q-btn-dropdown")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_MLBadge = _resolveComponent("MLBadge")!
  const _component_q_table = _resolveComponent("q-table")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _component_WaveformVerifyDialog = _resolveComponent("WaveformVerifyDialog")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.passagesDialog,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.passagesDialog) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { style: {"width":"700px","max-width":"90vw"} }, {
          default: _withCtx(() => [
            _createVNode(_component_q_toolbar, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_toolbar_title, { class: "text-blue-brand text-bold" }, {
                  default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                    _createTextVNode("Passages", -1)
                  ]))]),
                  _: 1
                }),
                _cache[6] || (_cache[6] = _createElementVNode("span", { class: "text-caption text-grey-7 q-mr-xs" }, "Marker Name:", -1)),
                _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.selectedMarkerName), 1),
                _createVNode(_component_q_space),
                (_ctx.sortedMarkers.length > 1)
                  ? (_openBlock(), _createBlock(_component_q_btn, {
                      key: 0,
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "chevron_left",
                      color: "blue-brand",
                      disable: _ctx.loading,
                      onClick: _withModifiers(_ctx.onPrevMarker, ["stop"])
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_tooltip, null, {
                          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                            _createTextVNode("Previous marker", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["disable", "onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.sortedMarkers.length > 1)
                  ? (_openBlock(), _createBlock(_component_q_btn, {
                      key: 1,
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "chevron_right",
                      color: "blue-brand",
                      disable: _ctx.loading,
                      onClick: _withModifiers(_ctx.onNextMarker, ["stop"])
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_tooltip, null, {
                          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                            _createTextVNode("Next marker", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["disable", "onClick"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_q_btn, {
                  flat: "",
                  round: "",
                  dense: "",
                  icon: "refresh",
                  loading: _ctx.loading,
                  onClick: _ctx.fetchPassages
                }, null, 8, ["loading", "onClick"]),
                _createVNode(_component_q_btn, {
                  flat: "",
                  round: "",
                  dense: "",
                  icon: "filter_alt",
                  color: _ctx.filterGreenMl ? 'green' : 'grey-6',
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.filterGreenMl = !_ctx.filterGreenMl))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_tooltip, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.filterGreenMl
                ? 'Showing green ML results only'
                : 'Filter to green ML results'), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["color"]),
                _withDirectives(_createVNode(_component_q_btn, {
                  flat: "",
                  round: "",
                  dense: "",
                  icon: "close",
                  onClick: _ctx.closeViewPsgs
                }, null, 8, ["onClick"]), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            }),
            (_ctx.errorMsg)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(_component_q_badge, {
                    class: "q-ml-sm",
                    color: "red"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.errorMsg), 1)
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_q_table, {
              pagination: _ctx.passagePagination,
              "onUpdate:pagination": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.passagePagination) = $event)),
              "table-header-class": "bg-blue-brand text-white",
              rows: _ctx.displayedPassages,
              columns: _ctx.passageColumns,
              "row-key": "passageId",
              dense: "",
              loading: _ctx.loading,
              "no-data-label": "No passages received"
            }, {
              "body-cell-graph-data": _withCtx((props) => [
                _createVNode(_component_q_td, { props: props }, {
                  default: _withCtx(() => [
                    (_ctx.isManualPassage(props.row))
                      ? (_openBlock(), _createBlock(_component_q_badge, {
                          key: 0,
                          color: "grey",
                          class: "q-mr-xs"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.getWaveformLabel('H')), 1)
                          ]),
                          _: 1
                        }))
                      : ((props.row.passageWaveforms || []).length === 1)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.row.passageWaveforms, (wf) => {
                              return (_openBlock(), _createBlock(_component_q_btn, {
                                key: wf.passageWaveformId,
                                size: "sm",
                                class: "q-mr-xs btn-brand",
                                dense: "",
                                icon: "show_chart",
                                label: _ctx.getWaveformLabel(wf.passageWaveformType),
                                onClick: ($event: any) => (_ctx.onShowChart(props.row, wf))
                              }, null, 8, ["label", "onClick"]))
                            }), 128))
                          ]))
                        : ((props.row.passageWaveforms || []).length > 1)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                              _createVNode(_component_q_btn_dropdown, {
                                size: "sm",
                                class: "q-mr-xs btn-brand",
                                dense: "",
                                icon: "show_chart"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_list, { dense: "" }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.row.passageWaveforms, (wf) => {
                                        return _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                          key: wf.passageWaveformId,
                                          clickable: "",
                                          onClick: ($event: any) => (_ctx.onShowChart(props.row, wf))
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_q_item_section, null, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_q_item_label, null, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_ctx.getWaveformLabel(wf.passageWaveformType)), 1)
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"])), [
                                          [_directive_close_popup]
                                        ])
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]))
                          : _createCommentVNode("", true),
                    (!props.row.passageId)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_5, "[manual passage] "))
                      : _createCommentVNode("", true),
                    (
                  !props.row.passageId &&
                  (_ctx.getuser() == 'admin' || _ctx.getuser() == 'superadmin')
                )
                      ? (_openBlock(), _createBlock(_component_q_btn, {
                          key: 4,
                          size: "sm",
                          class: "btn-brand",
                          dense: "",
                          color: "blue-brand",
                          icon: "edit",
                          onClick: ($event: any) => (_ctx.onConfirmEditManualPassage(props.row))
                        }, null, 8, ["onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1032, ["props"])
              ]),
              "body-cell-uid": _withCtx((props) => [
                _createVNode(_component_q_td, { props: props }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(props.value), 1)
                  ]),
                  _: 2
                }, 1032, ["props"])
              ]),
              "body-cell-verify-data": _withCtx((props) => [
                _createVNode(_component_q_td, { props: props }, {
                  default: _withCtx(() => [
                    (props.row.passageId)
                      ? (_openBlock(), _createBlock(_component_q_btn, {
                          key: 0,
                          size: "sm",
                          class: "btn-brand",
                          dense: "",
                          color: _ctx.isAnyWaveformVerified(props.row) ? 'green' : 'red',
                          icon: 
                  _ctx.isAnyWaveformVerified(props.row)
                    ? 'check_circle_outline'
                    : 'block'
                ,
                          onClick: ($event: any) => (_ctx.onVerifyPassage(props.row))
                        }, null, 8, ["color", "icon", "onClick"]))
                      : _createCommentVNode("", true),
                    (
                  !props.row.passageId &&
                  (_ctx.getuser() == 'admin' || _ctx.getuser() == 'superadmin')
                )
                      ? (_openBlock(), _createBlock(_component_q_btn, {
                          key: 1,
                          size: "sm",
                          class: "btn-brand",
                          dense: "",
                          color: "red",
                          icon: "delete",
                          onClick: ($event: any) => (_ctx.onConfirmDeleteManualPassage(props.row))
                        }, null, 8, ["onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1032, ["props"])
              ]),
              "body-cell-machine-learning-data": _withCtx((props) => [
                _createVNode(_component_q_td, { props: props }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getMLWaveforms(props.row), (wf) => {
                      return (_openBlock(), _createBlock(_component_MLBadge, {
                        key: wf.passageWaveformId,
                        type: wf.passageWaveformType,
                        prediction: wf.mlPrediction,
                        confidence: wf.mlConfidence,
                        results: wf.machineLearningResults
                      }, null, 8, ["type", "prediction", "confidence", "results"]))
                    }), 128))
                  ]),
                  _: 2
                }, 1032, ["props"])
              ]),
              _: 1
            }, 8, ["pagination", "rows", "columns", "loading"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_WaveformVerifyDialog, {
      ref: "waveformVerifyDialog",
      onConfirm: _ctx.onWaveformVerifyConfirm,
      onCancel: _ctx.onWaveformVerifyCancel
    }, null, 8, ["onConfirm", "onCancel"])
  ]))
}